export function getNavigationFocusStyle() {
    return {
        _focusVisible: {
            color: "semantic.text.primary",
            // using var because importing from color file would not work with dark/light
            boxShadow: `inset 0 0 0 3px $var(--chakra-colors-semantic-outline-focus)`,
            backgroundColor: "semantic.cta.secondaryHover",
        },
    };
}
//# sourceMappingURL=Navigation.helpers.js.map